export const MenuCardColors = [
  '#8F0608', '#9A4D05', '#A19404', '#006B3E', '#023A73'
];


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/home/component/left/utils.tsx